import React from 'react'

const FooterComponent = () => {
  return (
    <div>
        <footer className='p-3 border-t'>
          <p className='text-xl font-extrabold'>&copy; 2023. Christian Bork</p>
          <p>Built and designed by Christian Bork </p>
        </footer>
    </div>
  )
}

export default FooterComponent